import React from 'react';
import classes from './SubHeader.module.scss';
import { withRouter, Link } from 'react-router-dom';

const SubHeader = props => {
  return (
    <div className={classes.wrapper} {...props}>
      <Link to={props.backUrl} className={classes.btnBack}>
        <i className="far fa-arrow-left"></i> กลับ
      </Link>
      <div className={classes.line} />
      <div className={classes.content}>{props.children}</div>
    </div>
  );
};

export default withRouter(SubHeader);
